module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trinity-rings-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle1",
    style: (_vm.ring1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle2",
    style: (_vm.ring2Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle3",
    style: (_vm.ring3Style)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd34024e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/TrinityRingsSpinner.vue
// module id = 2295
// module chunks = 1